import Typography from "@portal/components/atoms/v2/typography";
import { GetIconForPlanningPage } from "../../helpers";
import { RadioGroup } from "@headlessui/react";
import { IPlanningOptionsProps } from "../types";
import RadioComponentWithSelectionBox from "@portal/components/atoms/v2/radioComponentWithSelectionBox";

export const PlanningOptions = ({ options, headers, selectedItem, onSelectionClick }: IPlanningOptionsProps) => (
  <div className="flex flex-col mt-2 mb-1.5">
    <RadioGroup value={selectedItem} onChange={onSelectionClick} className="space-y-3">
      {headers.map((header, i) => (
        <RadioComponentWithSelectionBox key={i} value={i} id={i.toString()} hideRadio smallPadding>
          {GetIconForPlanningPage(i)}
          <div className="flex flex-col p-2">
            <Typography variant="Bold">{header}</Typography>
            <Typography variant="Body">{options[i]}</Typography>
          </div>
        </RadioComponentWithSelectionBox>
      ))}
    </RadioGroup>
  </div>
);
